export default "__VITE_ASSET__B5kxj6wa__"